const basePath = 'workspace/examations'
export const ROUTER_WORKSPACE_EXAM_ROOM = {
	stages: `/${basePath}`,
	stage_detail: id => `/${basePath}/${id ?? ':id'}`,
	room_list: `/${basePath}/rooms`,
	room_detail: id => `/${basePath}/rooms/${id ?? ':id'}`
}
